import { stripeCustomerPortalUrl } from "../config";

export function prefillCustomerPortalLink({ email }: { email?: string }) {
  const url = new URL(stripeCustomerPortalUrl);
  const params = new URLSearchParams({
    prefilled_email: email ?? "",
  });

  url.search = params.toString();
  return url.toString();
}
